import { render, staticRenderFns } from "./PersonaDeudasView.vue?vue&type=template&id=b1147f88&scoped=true"
import script from "./PersonaDeudasView.vue?vue&type=script&lang=js"
export * from "./PersonaDeudasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1147f88",
  null
  
)

export default component.exports